import {DeleteRecordsConfirmationButton,} from '@flexinet/ui-components';

import {useApplications} from '../hooks/useApplications.ts';
import {useApplicationsSelection} from "../hooks/useApplicationsSelection.ts";

export const DeleteRecordButton = () => {

    const {deleteRecords} = useApplications();

    const {
        selection,
        handleClearSelection,
    } = useApplicationsSelection();

    const recordIds = Object.keys(selection);
    let disabled = true;
    if (recordIds.length > 0) {
        disabled = false;
    }


    return (<DeleteRecordsConfirmationButton
        disabled={disabled}
        recordIdsLength={recordIds.length}
        handleConfirm={() => {
            deleteRecords()
            handleClearSelection()
        }}/>);
};
